import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { FetchProfileResponse, ProfileResponse } from '@shared/models';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';


@Injectable()
export class ProfileService {
  private _http = inject(HttpClient);
  public _apiUrl = environment.apiUrl;
  private _authHeaders = new HttpHeaders({
    Authorization: '',
  });

  fetchProfile(): Observable<ProfileResponse> {
    const userId = localStorage.getItem('userId');

    return this._http
      .get<FetchProfileResponse>(
        `${this._apiUrl}/api/client/profile/${userId}`,
        {
          headers: this._authHeaders,
        }
      )
      .pipe(map((resp) => resp.message));
  }

}
